module.exports = __webpack_public_path__ + "img/img2.63b77661.jpg";